export default __webpack_public_path__ + "static/media/tms-arge.e63cb2e2.pdf";